import { Component } from "react";
import authStore from "../../store/authStore";

const PENDO_API_KEY = import.meta.env.VITE_APP_PENDO_API_KEY;
const APP_NAME = "NO_CODE";
const isInProduction = import.meta.env.PROD;

export default class InstrumentationProvider extends Component {
  initializePendo() {
    (function (p, e, n, d, o) {
      var v, w, x, y, z;
      o = p[d] = p[d] || {};
      o._q = o._q || [];
      v = ["initialize", "identify", "updateOptions", "pageLoad", "track"];
      for (w = 0, x = v.length; w < x; ++w)
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? "unshift" : "push"]([m].concat([].slice.call(arguments, 0)));
            };
        })(v[w]);
      y = e.createElement(n);
      y.async = !0;
      y.src = "https://cdn.pendo.io/agent/static/" + PENDO_API_KEY + "/pendo.js";
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, "script", "pendo");
  }

  startPendo({ email, organizationHubspotId }) {
    this.initializePendo();

    window.pendo.initialize({
      visitor: {
        id: email,
        email,
        appName: APP_NAME,
      },
      account: {
        id: organizationHubspotId,
      },
    });
  }

  componentDidMount() {
    const { decodedTokenData } = authStore;

    if (decodedTokenData && isInProduction) {
      const { email, organizationHubspotId } = decodedTokenData;

      this.startPendo({
        email,
        organizationHubspotId,
      });
    }
  }

  render() {
    return this.props.children;
  }
}
